import { SuppliersPanel } from '../components/suppliers/SuppliersPanel';
import { Breadcrumb } from '../components/ui/Breadcrumb';
import page from './Page.module.css';

export function SuppliersPage() {
  return (
    <div>
      <Breadcrumb items={[{ label: 'Suppliers' }]} />
      <h1 className={page.title}>Suppliers</h1>
      <p className={page.muted} style={{ marginBottom: 20 }}>
        View supplier pricing and price history. Export current prices to Excel.
      </p>
      <SuppliersPanel isAdmin={false} />
    </div>
  );
}
